export default __webpack_public_path__ + "media/images/images/raty/star-on-2-533b6fe98e1c2305a6688f51ebf69e3d.png";